import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getProviderTickets } from "../slice/providerTicketSlice";
import ProviderHeader from "../../provider-header/components/index";

import Pagination from "../../../../pagination/components";

const ProviderTicketList = () => {
  
  const dispatch = useDispatch();
  const { providerTickets, loading, error, pagination } = useSelector((state) => state.providerTickets);
  const [page, setPage] = useState(1);

    useEffect(() => {
    dispatch(getProviderTickets(page));
  }, [dispatch, page]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.last_page) {
      setPage(newPage);
    }
  };

   console.log("tickets", providerTickets);
   console.log("pagination", pagination);

  return (
    <>
      <ProviderHeader />
      <div className="container mt-4">
        <div className="d-flex justify-content-between">
        <h4 className="mb-3">Provider Ticket List</h4>
        <Link to="/provider/add-ticket"><button className="btn btn-primary">Add ticket</button></Link>
        </div>
        
<table className="table table-striped">
  <thead className="table-dark">
    <tr>
      <th>#</th>
      <th>Title</th>
      <th>Description</th>
      <th>Status</th>
      <th>Document</th>
    </tr>
  </thead>
  <tbody>
    {loading ? (
      <tr>
        <td colSpan="5" className="text-center">Loading...</td>
      </tr>
    ) : error ? (
      <tr>
        <td colSpan="5" className="text-danger text-center">
          {typeof error === "string" ? error : error?.error || "An error occurred"}
        </td>
      </tr>
    ) : providerTickets.length === 0 ? (
      <tr>
        <td colSpan="5" className="text-center">No tickets found.</td>
      </tr>
    ) : (
      providerTickets.map((ticket, index) => (
        <tr key={ticket.id}>
          <td>{index + 1}</td>
          <td>{ticket.title}</td>
          <td>{ticket.description}</td>
          <td>{ticket.status}</td>
          <td>{ticket.document}</td>
        </tr>
      ))
    )}
  </tbody>
</table>

        <Pagination
                      currentPage={page}
                      totalPages={pagination.last_page || 0}
                      onPageChange={handlePageChange}
                    />
      </div>
    </>
  );
};

export default ProviderTicketList;
